import { render, staticRenderFns } from "./OptionList.vue?vue&type=template&id=4db6fef1"
import script from "./OptionList.vue?vue&type=script&lang=js"
export * from "./OptionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db6fef1')) {
      api.createRecord('4db6fef1', component.options)
    } else {
      api.reload('4db6fef1', component.options)
    }
    module.hot.accept("./OptionList.vue?vue&type=template&id=4db6fef1", function () {
      api.rerender('4db6fef1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/CompanySwitcher/OptionList.vue"
export default component.exports